import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import css from './ExitIcon.module.scss';

export const ExitIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <IconButton className={css.exitIcon} onClick={onClick}>
      <CloseIcon fontSize="inherit" />
    </IconButton>
  );
};
